var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClicktopay = function SvgClicktopay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 580.6 366.7",
    style: {
      enableBackground: "new 0 0 580.6 366.7"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "clicktopay_svg__a",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 580.6,
    height: 366.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 580.6,
    height: 366.7,
    id: "clicktopay_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#clicktopay_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    },
    d: "M.5 0h580.1v366.6H.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M436.9 8.4C434 3.6 428.7.3 422.6.3c-9.2 0-16.7 7.5-16.7 16.8 0 4.9 2.1 9.3 5.4 12.4l125.9 153.4-124.5 150.5H358.9l117.7-137.6c.1-.1.1-.2.2-.3 3.3-3.6 4.7-7.9 4.7-12 .1-4.2-1.4-8.4-4.7-12-.1-.1-.1-.2-.2-.3L336 8.7l-.1-.1C333 3.7 327.6.4 321.5.4h-98.7c-9.2 0-16.7 7.5-16.7 16.8 0 2.8.4 5.7 1.9 7.8l130.8 159.2-111.4 134.3c-.7.7-10.3 14.4-27.2 14.4H66.6c-18.1 0-33.1-14.2-33.1-33.1v-233c0-16.4 15-33.3 33.5-33.3h83.3c9.8 0 16.7-6.7 16.7-16.5S160.1-.1 150.3-.1L66.2.3C26.6.3 0 33.2 0 66.6v233.3c0 35.9 31.5 66.6 66.2 66.6h133.6c6.7 0 12.9-1 18.4-2.6.8-.2 1.6-.5 2.3-.7 18.3-6 29.4-18.3 31.6-20.9l125.4-146.9c5.9-6.8 6.7-16.6.1-23.9-.1-.1-.1-.2-.2-.3L258.7 33.6H313.5l124 149.9L307 341.7s0 .2.2.4c-1.2 2.3-1.9 5-1.9 7.8 0 9.3 7.5 16.8 16.7 16.8h98.7c6.1 0 11.5-3.3 14.4-8.2l.1-.1 140.5-162.6c.1-.1.1-.2.2-.3 6.6-7.3 5.8-17.1-.1-23.9L436.9 8.4z",
    style: {
      mask: "url(#clicktopay_svg__b)"
    }
  }));
};
export default SvgClicktopay;